import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';

export enum FeaturePathEnum {
  BULK_MESSAGING = 'bulk-messaging',
  CALL_INTELLIGENCE = 'call-intelligence',
  EMAIL_MARKETING = 'email-marketing',
  FORMS = 'forms',
  ONLINE_SCHEDULING = 'online-scheduling',
  PRACTICE_ANALYTICS = 'practice-analytics',
  TEXT_CONNECT = 'text-connect',
  WEAVE_VERIFY = 'insurance-verification',
  WEAVE_INSURANCE_ELIGIBILITY = 'weave-insurance-eligibility',
  VOICE_AI_RECEPTIONIST = 'ai-receptionist',
}

export const FeatureToPathEnumMap: Partial<Record<Feature, FeaturePathEnum>> = {
  [Feature.BULK_MESSAGING]: FeaturePathEnum.BULK_MESSAGING,
  [Feature.CALL_INTELLIGENCE]: FeaturePathEnum.CALL_INTELLIGENCE,
  [Feature.EMAIL_MARKETING]: FeaturePathEnum.EMAIL_MARKETING,
  [Feature.FORMS]: FeaturePathEnum.FORMS,
  [Feature.ONLINE_SCHEDULING]: FeaturePathEnum.ONLINE_SCHEDULING,
  [Feature.PRACTICE_ANALYTICS]: FeaturePathEnum.PRACTICE_ANALYTICS,
  [Feature.TEXT_CONNECT]: FeaturePathEnum.TEXT_CONNECT,
  [Feature.WEAVE_VERIFY]: FeaturePathEnum.WEAVE_VERIFY,
  [Feature.ENHANCED_INSURANCE_VERIFICATION]: FeaturePathEnum.WEAVE_INSURANCE_ELIGIBILITY,
  [Feature.TRUELARK_AI_VOICE]: FeaturePathEnum.VOICE_AI_RECEPTIONIST,
};

export const PathEnumToFeatureMap: Record<FeaturePathEnum, Feature> = {
  [FeaturePathEnum.BULK_MESSAGING]: Feature.BULK_MESSAGING,
  [FeaturePathEnum.CALL_INTELLIGENCE]: Feature.CALL_INTELLIGENCE,
  [FeaturePathEnum.EMAIL_MARKETING]: Feature.EMAIL_MARKETING,
  [FeaturePathEnum.FORMS]: Feature.FORMS,
  [FeaturePathEnum.ONLINE_SCHEDULING]: Feature.ONLINE_SCHEDULING,
  [FeaturePathEnum.PRACTICE_ANALYTICS]: Feature.PRACTICE_ANALYTICS,
  [FeaturePathEnum.TEXT_CONNECT]: Feature.TEXT_CONNECT,
  [FeaturePathEnum.WEAVE_VERIFY]: Feature.WEAVE_VERIFY,
  [FeaturePathEnum.WEAVE_INSURANCE_ELIGIBILITY]: Feature.ENHANCED_INSURANCE_VERIFICATION,
  [FeaturePathEnum.VOICE_AI_RECEPTIONIST]: Feature.TRUELARK_AI_VOICE,
};
